export const editorBaseClasses = 'wysiwyg prose prose-sm sm:prose lg:prose-lg focus:outline-hidden';
